// extracted by mini-css-extract-plugin
export default {"main":"_8c86d2f62a _57af796859","xmark":"ab543f1332","fl_img":"_97a8c428ef _03ea140278"};